var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shapes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M14.6875 8.75H13.75H8.75C5.3 8.75 2.5 11.55 2.5 15V21.25C2.5 24.7 5.3 27.5 8.75 27.5H15C18.45 27.5 21.25 24.7 21.25 21.25V16.25V15.3125C21.25 11.6875 18.3125 8.75 14.6875 8.75Z",
    fill: "var(--fill-0, #0C0C0C)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.625 2.5C17.0375 2.5 14.1 5.25 13.7875 8.75H14.6875C18.3125 8.75 21.25 11.6875 21.25 15.3125V16.2125C24.75 15.9 27.5 12.95 27.5 9.375C27.5 5.575 24.425 2.5 20.625 2.5Z",
    fill: "var(--fill-0, #0C0C0C)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShapes);
export default __webpack_public_path__ + "static/media/icon-shapes.9d5cbe23a504dd82161494b74f93ba06.svg";
export { ForwardRef as ReactComponent };